module.exports = __webpack_public_path__ + "img/D3F2_new.5b14efef.jpg";